import {useState, useEffect} from 'react';
import {
    NUM_TRACKS,
} from './constants.js';

export const useFilterWorks = ({
    allSequences,
    personSelected,
    searchOptions,
    searchTerm,
    setState
}) => {
    const [isLoading, setIsLoading] = useState(false);    
    let userWorks = allSequences.filter(
        s => !personSelected || s.user === personSelected.id);
    let filterSounds = searchOptions.indexOf("Samples") > -1;
    let filterProjects = searchOptions.indexOf("Projects") > -1;
    let filterLists = searchOptions.indexOf("Lists") > -1;
    
    userWorks = userWorks 
        .filter(s =>
                (filterLists && s.type === "LIST") ||
                (filterSounds && (s.type === 'SAMPLES' || s.type === "MIX")) ||
                (filterProjects && s.type === 'SEQUENCE'));
    
    let works = [... userWorks];
    
    useEffect(() => {
        console.log("GOING TO BEGINNING");
        setState({
            scrollTo: 0,
            numTracks: NUM_TRACKS
        });
        let el = document.getElementById('works');
        el.scrollTo(0, 0);
    }, [searchTerm, searchOptions, setState]);
    
    useEffect(() => {
        setState({numTracks: NUM_TRACKS, scrollTop: 0});
    }, [personSelected]);
    
    return {works, userWorks, isLoading, setIsLoading};
};
